import { useState } from 'react';
import { useOnChangeState } from 'hooks';

const useStateWithChange = (initialState = undefined) => {
	const [ value, setValue ] = useState(initialState);
	const {
		onChange,
		isChanged,
		setChanged,
	} = useOnChangeState(setValue);

	return [
		value,
		setValue,
		onChange,
		{
			isChanged,
			setChanged,
		}
	];
};

export default useStateWithChange;